import React, { CSSProperties, MouseEventHandler } from 'react';
import { Link } from 'react-router-dom';

type WebComponentsLinkProps = {
  to: string | undefined;
  className?: string;
  style?: CSSProperties;
  onClick?: MouseEventHandler;
  target?: string;
};

export const WebComponentsLink = ({ to, ...rest }: WebComponentsLinkProps) => {
  return <Link to={{ pathname: to }} {...rest} />;
};
